<app-qr></app-qr>
<!DOCTYPE html>
<html lang="en">
  <head>
    <!-- Required meta tags -->
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <title>NorsupOne</title>
  </head>
  <body>
   <div class="container-fluid">
      <div class="row gx-0">
        <div class="col-lg-12 d-flex">
          <div class="side-menu">
            <app-side-bar></app-side-bar>
          </div>
          <div class="right-side">
            <div class="pt-3">
              <div class="glass-bg w-100">
                <div class="d-flex pb-4 pt-2 px-3 title-cell-block">
                  <div class="flex-grow-1">
                    <div class="title-cell">
                      <div class="title">Overview</div>
                      <div>
                        <div class="dropdown refresh-dropdown">
                          <button
                            class="refresh-rate-btn dropdown-toggle"
                            type="button"
                            id="dropdownMenuButton1"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <img
                              src="assets/img/refresh-ico.svg"
                              alt="refresh"
                            /><span class="ps-1"
                              >View:
                              <i class="selected-value">{{
                                get_view_selected()
                              }}</i></span
                            >
                          </button>
                          <ul
                            class="dropdown-menu"
                            aria-labelledby="dropdownMenuButton1"
                          >
                            <li>
                              <a
                                class="dropdown-item"
                                (click)="view_selector('Grid view')"
                                >Grid view</a
                              >
                            </li>
                            <li>
                              <a
                                class="dropdown-item"
                                (click)="view_selector('Table view')"
                                >Table view</a
                              >
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div>
                        <div class="dropdown refresh-dropdown">
                          <button
                            class="refresh-rate-btn"
                            type="button img-align"
                            id="dropdownMenuButton1"
                          >
                          <img
                              src="assets/Expand_Icon.svg"
                              alt="fullscreen"
                            />
                            <span class="ps-1">
                              <i
                                class="selected-value"
                                (click)="fullscreen()"
                                >{{ get_current_mode() }}</i
                              ></span
                            >
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex search-cell">
                    <div class="search-container">
                      <form
                        action=""
                        method="get"
                        (ngSubmit)="search(searchTerm)"
                      >
                        <input
                          class="search expandright"
                          id="searchright"
                          type="search"
                          [(ngModel)]="searchTerm"
                          name="searchTerm"
                          placeholder="Search"
                          (input)="onInput()"
                        />
                        <label class="button searchbutton" for="searchright"
                          ><span class="mglass">&#9906;</span></label
                        >
                      </form>
                    </div>
                  </div>
                </div>

                <div *ngIf="get_view()">
                  <div class="wrapper row gx-0">
                    <div
                      class="loader-container"
                      *ngIf="!controller_specific_info"
                    >
                      <span class="loader"></span>
                    </div>
                    <div>
                      <span *ngIf="noDataCheck()"
                        ><i class="fa fa-ban" aria-hidden="true"></i
                      ></span>
                    </div>
                    <div>
                      <span class="search-result" *ngIf="noDataCheck()"
                        >NO RESULTS FOUND</span
                      >
                    </div>
                    <div
                      class="col item item-1 order-lg-1 order-md-3 order-sm-3"
                      *ngIf="normal_user.length > 0"
                    >
                      <h4 class="user-type ps-3">No Alarms Users</h4>
                      <div class="box-first">
                        <div class="test-scroll">
                          <div
                            class="block-container"
                            *ngFor="let info of normal_user"
                            (click)="onCardClick(info)"
                          >
                            <div class="btn-back btn-back-1"></div>
                            <div class="btn-front">
                              <div class="user-info d-flex">
                                <div class="d-flex align-items-center">
                                  <div
                                    [ngClass]="{
                                      icon:
                                        get_controller_status(
                                          info.controller_uuid
                                        ) === 'online',
                                      'icon-offline':
                                        get_controller_status(
                                          info.controller_uuid
                                        ) === 'offline'
                                    }"
                                  ></div>
                                </div>
                                <div
                                  class="user-name ps-2"
                                  [ngClass]="{
                                    inactive_username:
                                      get_controller_status(
                                        info.controller_uuid
                                      ) === 'offline'
                                  }"
                                >
                                  {{ info.firstname }} {{ info.lastname }}
                                </div>
                              </div>
                              <div class="pt-3 d-flex">
                                <div>
                                  <img src="assets/img/ph.svg" alt="ph" />
                                </div>
                                <div class="ps-1">
                                  <div class="parameter-value">
                                    {{
                                      get_phValue(
                                        info.controller_uuid
                                      )
                                    }}
                                  </div>
                                  <div class="parameter-label">pH</div>
                                </div>
                              </div>

                              <div class="pt-2 d-flex">
                                <div>
                                  <img src="assets/img/orp.svg" alt="org" />
                                </div>
                                <div class="ps-1">
                                  <div class="parameter-value">
                                    {{
                                      get_orpValue(
                                        info.controller_uuid
                                      )
                                    }}mV
                                  </div>
                                  <div class="parameter-label">ORP</div>
                                </div>
                              </div>

                              <div class="pt-2 d-flex">
                                <div>
                                  <img src="assets/img/temp.svg" alt="temp" />
                                </div>
                                <div class="ps-1">
                                  <div class="parameter-value">
                                    {{
                                      get_temperatureValue(
                                        info.controller_uuid
                                      )
                                    }}°C
                                  </div>
                                  <div class="parameter-label">Temp</div>
                                </div>
                              </div>
                              <div class="pt-2 d-flex" style="gap: 4px;">
                                <div class="ps-1" >
                                  <img src="assets/img/acid-conc-web.svg" alt="acid" />
                                </div>
                                <div class="ps-1">
                                  <div class="parameter-value">
                                    {{
                                      get_phConcentrationValue(
                                        info.controller_uuid
                                      )
                                    }}%
                                  </div>
                                  <div class="parameter-label">Acid Conc.</div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="col item item-2 order-lg-2 order-md-2 order-sm-2"
                      *ngIf="info_user.length > 0"
                    >
                      <h4 class="user-type ps-3">Info Alarm Users</h4>
                      <div class="box-first">
                        <div
                          [ngClass]="{
                            'info-alarm-scroll': info_user.length > 2,
                            'info-alarm-scroll-2': info_user.length <= 2
                          }"
                        >
                          <div
                            class="block-container-major"
                            *ngFor="let info of info_user"
                            (click)="onCardClick(info)"
                          >
                            <div class="btn-back btn-back-1"></div>
                            <div class="btn-front">
                              <div class="user-info d-flex">
                                <div class="d-flex align-items-center">
                                  <div
                                    [ngClass]="{
                                      icon:
                                        get_controller_status(
                                          info.controller_uuid
                                        ) === 'online',
                                      'icon-offline':
                                        get_controller_status(
                                          info.controller_uuid
                                        ) === 'offline'
                                    }"
                                  ></div>
                                </div>
                                <div
                                  class="user-name ps-2"
                                  [ngClass]="{
                                    inactive_username:
                                      get_controller_status(
                                        info.controller_uuid
                                      ) === 'offline'
                                  }"
                                >
                                  {{ info.firstname }} {{ info.lastname }}
                                  {{
                                    save_alert_code(
                                      info.controller_uuid,
                                      info.controller_details
                                    )
                                  }}
                                </div>
                              </div>
                              <div class="d-flex align-items-center pt-1">
                                <div class="set-value-dot"></div>
                                <div class="set-value ps-1">Set value</div>
                              </div>
                              <div class="pt-3 d-flex">
                                <div>
                                  <img src="assets/img/ph.svg" alt="ph" />
                                </div>
                                <div class="ps-1">
                                  <div class="parameter-value">
                                    {{
                                      get_phValue(
                                        info.controller_uuid
                                      )
                                    }}<span class="user-set-value">{{
                                      get_setPhValue(
                                        info.controller_uuid
                                      )
                                    }}</span>
                                  </div>
                                  <div class="parameter-label">pH</div>
                                </div>
                              </div>

                              <div class="pt-2 d-flex">
                                <div>
                                  <img src="assets/img/orp.svg" alt="orp" />
                                </div>
                                <div class="ps-1">
                                  <div class="parameter-value">
                                    {{
                                      get_orpValue(
                                        info.controller_uuid
                                      )
                                    }}mV<span class="user-set-value">{{
                                      get_setOrpValue(
                                        info.controller_uuid
                                      )
                                    }}</span>
                                  </div>
                                  <div class="parameter-label">ORP</div>
                                </div>
                              </div>

                              <div class="pt-2 d-flex">
                                <div>
                                  <img src="assets/img/temp.svg" alt="temp" />
                                </div>
                                <div class="ps-1">
                                  <div class="parameter-value">
                                    {{
                                      get_temperatureValue(
                                        info.controller_uuid
                                      )
                                    }}°C
                                  </div>
                                  <div class="parameter-label">Temp</div>
                                </div>
                              </div>
                              
                              <div class="pt-2 d-flex" style="gap: 4px;">
                                <div class="ps-1" >
                                  <img src="assets/img/acid-conc-web.svg" alt="acid" />
                                </div>
                                <div class="ps-1">
                                  <div class="parameter-value">
                                    {{
                                      get_phConcentrationValue(
                                        info.controller_uuid
                                      )
                                    }}%
                                  </div>
                                  <div class="parameter-label">Acid Conc.</div>
                                </div>
                              </div>
             
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="col item item-3 order-lg-3 order-md-1 order-sm-1"
                      *ngIf="critical_user.length > 0"
                    >
                      <h4 class="user-type-critical ps-3">
                        Critical Alarm Users
                      </h4>
                      <div class="critical-box">
                        <div class="test-scroll">
                          <div
                            class="block-container-critical"
                            *ngFor="let info of critical_user"
                            
                          >
                            <div class="btn-back btn-back-1"></div>
                            <div class="btn-front p-0">
                              <div class="alarm-info" (click)="onCardClick(info)">
                                <h6>Alarms</h6>
                                <h5>
                                  Total alarms<span>{{
                                    info.total_count
                                  }}</span>
                                </h5>

                                <div
                                  *ngFor="let alerts of info.controller_details"
                                >
                                  <div class="d-flex mb-1">
                                    <div>
                                      <img
                                        [src]="getImagePath(alerts.device_id)"
                                        width="25"
                                        alt="alerts"
                                      />
                                    </div>
                                    <div class="alarm-device-title">
                                      {{ alerts.device_id }}
                                    </div>
                                  </div>
                                  <ul
                                    class="alarm-list m-0 p-0"
                                    *ngFor="let alerts_code of alerts.alerts"
                                  >
                                    <li>
                                      <span
                                        [ngClass]="{
                                          'critical-alarm-label':
                                            alerts_code.alert_type === 1,
                                          'major-alarm-label':
                                            alerts_code.alert_type === 2
                                        }"
                                        [ngbPopover]="popoverContent"
                                        triggers="mouseenter:mouseleave"
                                        >{{ alerts_code.alert_code }}
                                        {{
                                          save_alert_code(
                                            info.controller_uuid,
                                            info.controller_details
                                          )
                                        }}</span
                                      >
                                      <ng-template #popoverContent>
                                        <div class="small-popover-content">
                                          {{ alerts_code.alert_message }}
                                        </div>
                                      </ng-template>
                                    </li>
                                    <div class="both"></div>
                                  </ul>
                                </div>
                              </div>

                              <div class="critical-user-info">
                                <div class="user-info d-flex">
                                  <div class="d-flex align-items-center">
                                    <div
                                      [ngClass]="{
                                        icon:
                                          get_controller_status(
                                            info.controller_uuid
                                          ) === 'online',
                                        'icon-offline':
                                          get_controller_status(
                                            info.controller_uuid
                                          ) === 'offline'
                                      }"
                                    ></div>
                                  </div>
                                  <div
                                    class="user-name ps-2"
                                    [ngClass]="{
                                      inactive_username:
                                        get_controller_status(
                                          info.controller_uuid
                                        ) === 'offline'
                                    }"
                                  >
                                    {{ info.firstname }} {{ info.lastname }}
                                  </div>
                                </div>
                                <div class="d-flex align-items-center pb-2">
                                  <div class="set-value-dot"></div>
                                  <div class="set-value ps-1">Set value</div>
                                </div>
                                <div class="qr-code">
                                  <qr-code
                                    value="{{
                                      get_controller_qr(info.controller_uuid)
                                    }}"
                                    size="100"
                                    errorCorrectionLevel="H"
                                    (click)="
                                      qrOpenView(
                                        info.user_id,
                                        info.controller_uuid
                                      )
                                    "
                                  ></qr-code>
                                </div>
                                <div class="pt-2 d-flex">
                                  <div class="color-indication text-center">
                                    <div class="bar-holder">
                                      <app-ph-guage
                                        [gaugeValue]="
                                          get_controller_telemetry(
                                            info.controller_uuid,
                                            'ph'
                                          )
                                        "
                                      ></app-ph-guage>
                                    </div>
                                  </div>
                                  <div class="ps-1">
                                    <div class="parameter-value">
                                      {{
                                        get_phValue(
                                        info.controller_uuid
                                      )
                                      }}<span class="user-set-value">{{
                                        get_setPhValue(
                                          info.controller_uuid
                                        )
                                      }}</span>
                                    </div>
                                    <div class="parameter-label">pH</div>
                                  </div>
                                </div>

                                <div class="pt-2 d-flex">
                                  <div class="color-indication text-center">
                                    <div class="bar-holder">
                                      <app-guage
                                        [gaugeValue]="
                                          get_controller_telemetry(
                                            info.controller_uuid,
                                            'orp'
                                          )
                                        "
                                      ></app-guage>
                                    </div>
                                  </div>
                                  <div class="ps-1">
                                    <div class="parameter-value">
                                      {{
                                        get_orpValue(
                                        info.controller_uuid
                                      )
                                      }}mV<span class="user-set-value">{{
                                        get_setOrpValue(
                                          info.controller_uuid
                                        )
                                      }}</span>
                                    </div>
                                    <div class="parameter-label">ORP</div>
                                  </div>
                                </div>

                                <div class="pt-2 d-flex">
                                  <div class="color-indication text-center">
                                    <div class="bar-holder">
                                      <app-temp-guage
                                        [gaugeValue]="
                                        get_temperatureValue(
                                          info.controller_uuid
                                        )
                                        "
                                      ></app-temp-guage>
                                    </div>
                                  </div>
                                  <div class="ps-1">
                                    <div class="parameter-value">
                                      {{
                                        get_temperatureValue(
                                        info.controller_uuid
                                      )
                                      }}°C
                                    </div>
                                    <div class="parameter-label">Temp</div>
                                  </div>
                                </div>


                                <div class="pt-2 d-flex">
                                  <div class="color-indication text-center">
                                    <div class="bar-holder">
                                      <app-acid-conc-guage
                                        [gaugeValue]="
                                        get_phConcentrationValue(
                                          info.controller_uuid
                                        )
                                        "
                                      ></app-acid-conc-guage>
                                    </div>
                                  </div>
                                  <div class="ps-1">
                                    <div class="parameter-value">
                                      {{
                                        get_phConcentrationValue(
                                        info.controller_uuid
                                      )
                                      }}%
                                    </div>
                                    <div class="parameter-label">Acid Conc.</div>
                                  </div>
                                </div>




                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="" *ngIf="!get_view()">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="user-type user-table-list">
                        <div class="table-list rounded p-3">
                          <ng-container style="border: None">
                            <table
                              class="table table-dark table-hover custome-table"
                            >
                              <caption hidden="true">
                                Inventory
                              </caption>
                              <thead>
                                <tr>
                                  <th
                                    scope="col"
                                    class="table-view table-view-heading"
                                  >
                                    USERNAME
                                  </th>
                                  <th
                                    scope="col"
                                    class="table-view table-view-heading"
                                  >
                                    CONTROLLER UUID
                                  </th>
                                  <th
                                    scope="col"
                                    class="table-view table-view-heading"
                                  >
                                    TOTAL ALARMS
                                  </th>
                                  <th
                                    scope="col"
                                    class="table-view table-view-heading"
                                  >
                                    CONTROLLER STATUS
                                  </th>
                                  <th 
                                  scope="col"
                                  class="table-view table-view-heading"
                                >
                                  CONTROLLER STATE
                                </th>
                                </tr>
                              </thead>
                              <tbody *ngFor="let controller of paginatedInfo">
                                <tr
                                  [ngClass]="{
                                    'critical-view':
                                      getUserType(controller.controller_uuid) ==
                                      'critical',
                                    'info-view':
                                      getUserType(
                                        controller.controller_uuid
                                      ) === 'info'
                                  }"
                                >
                                  <!-- getUserType -->
                                  <td class="table-view">
                                    {{ controller.firstname }}
                                    {{ controller.lastname }}
                                  </td>
                                  <td
                                    class="table-view"
                                    style="cursor: pointer"
                                    (click)="
                                      qrOpenView(
                                        controller.user_id,
                                        controller.controller_uuid
                                      )
                                    "
                                  >
                                    <i
                                      class="fa fa-qrcode"
                                      style="font-size: 200%"
                                    ></i>
                                  </td>
                                  <td class="table-view">
                                    <span
                                      ngbPopover="{{
                                        get_alert_code(
                                          controller.controller_uuid
                                        )
                                      }}"
                                      triggers="mouseenter:mouseleave"
                                    >
                                      {{ controller.total_count }}
                                    </span>
                                  </td>
                                  <td class="table-view">
                                    <span
                                      [ngClass]="{
                                        'table-status-online':
                                          get_controller_status(
                                            controller.controller_uuid
                                          ) === 'online',
                                        'table-status-offline':
                                          get_controller_status(
                                            controller.controller_uuid
                                          ) === 'offline'
                                      }"
                                      >{{
                                        get_controller_status(
                                          controller.controller_uuid
                                        )
                                      }}</span
                                    >
                                  </td>
                                  <td class="table-view user_active" *ngIf="isAdmin">
                                    <input
                                    id="toggle-button"
                                    type="checkbox"
                                    [checked]="controller.controller_status === 'Active'"
                                    (change)="updateControllerStatus(controller.controller_uuid, $event)"
                                  />        
                                  </td>
                                  <td class="table-view" *ngIf="!isAdmin">
                                    <span triggers="mouseenter:mouseleave">{{get_controller_state(controller.controller_status)}} </span>
                                     
                                </td>                
                                </tr>
                              </tbody>
                            </table>
                          </ng-container>
                        </div>
                      </div>
                      <div
                        class="text-center d-flex justify-content-center dashboard-pagination"
                      >
                        <ng-container
                          *ngIf="
                            controller_specific_info && !getProfileOpenStatus()
                          "
                        >
                          <ngb-pagination
                            [(page)]="currentPage"
                            [pageSize]="itemsPerPage"
                            [collectionSize]="controller_specific_info.length"
                            (pageChange)="pageChanged($event)"
                            style="z-index: 0"
                          ></ngb-pagination>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                  <div></div>
                </div>
       </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </body>
</html>
